// extracted by mini-css-extract-plugin
export default {"root":"OfferCardTitle_root__qQxvn","salesDescription":"OfferCardTitle_salesDescription__tt2p-","title":"OfferCardTitle_title__W2gr7"};